export default "__VITE_ASSET__CNzXv7Tk__"